import { Avatar } from "@mui/material";
import Chip from "components/Chip";
import Input from "components/Input";
import RangePicker from "components/RangePicker";
import SearchCasesNew from "components/SearchCasesNew";
import SearchLabel from "components/SearchLabel";
import SearchMemberNew from "components/SearchMemberNew";
import { ICaseSimple } from "dto/Cases/ICaseSimple";
import { ITag, TagType } from "dto/ITag";
import { IWorkspaceMember } from "dto/IWorkspace";
import { FC, RefObject, useRef } from "react";
import { convertToLetters } from "utils/convertToLetters";
import { formatDate } from "utils/formatDate";
import styles from "./styles.module.scss";
import moment from "moment";
import { useTranslation } from "react-i18next";
import RichEditor from "components/RichEditor";
import { ICalendar } from "dto/IBusyDate";
import SelectCalendar from "components/SelectCalendar";

interface EventFormProps {
  c: ICaseSimple | null;
  setCase: (cas: ICaseSimple | null) => void;
  title: string;
  setTitle: (title: string) => void;
  content: string;
  setContent: (content: string) => void;
  tags: ITag[];
  setTags: (tags: ITag[]) => void;
  members: IWorkspaceMember[];
  setMembers: (members: IWorkspaceMember[]) => void;
  startDate: Date | undefined;
  setStartDate: (date: Date | undefined) => void;
  endDate: Date | undefined;
  setEndDate: (date: Date | undefined) => void;
  setAllDay(state: boolean): void;
  allDay: boolean;
  calendar: ICalendar;
  setCalendar: (calendar: ICalendar) => void;
}

const EventForm: FC<EventFormProps> = ({
  c,
  setCase,
  title,
  setTitle,
  content,
  setContent,
  tags,
  setTags,
  members,
  setMembers,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  setAllDay,
  allDay,
  calendar,
  setCalendar,
}) => {
  const { t } = useTranslation();
  console.log(allDay);
  const ref = useRef<RefObject<HTMLDivElement>>(null);
  return (
    <>
      <div ref={ref} className={styles.inputs}>
        <SearchCasesNew
          settedCase={c}
          setAddNewEntity={() => {}}
          onChoose={(cas) => setCase(cas)}
        />

        <Input value={title} onChange={(e) => setTitle(e)} label={t("forms.title")} />

        <div className={styles.controls}>
          <RangePicker
            allowOneDate
            defaultDates={
              startDate && endDate ? [startDate, endDate] : undefined
            }
            onChangeIsFullDay={(state) => {
              setAllDay(state);
            }}
            onAccept={(dateRange) => {
              setStartDate(dateRange[0]!.toDate());
              setEndDate(dateRange[1]!.toDate());
            }}
          />
          <SearchLabel
            label={t("common.label")}
            type={TagType.Events}
            onChoose={(tag) => {
              const isExist = tags.find((t) => t.Name === tag?.Name);
              if (isExist) return;
              setTags([...tags, tag!]);
            }}
          />

          <SearchMemberNew
            onChoose={(member) => {
              setMembers([...members, member as IWorkspaceMember]);
            }}
          />

          <SelectCalendar
            selected={calendar}
            onChoose={(c) => setCalendar(c)}
          ></SelectCalendar>
        </div>
        <div className={styles.list}>
          {moment(startDate).isValid() && startDate && (
            <Chip
              element={<>{formatDate([startDate, endDate], allDay)}</>}
              onDelete={() => {
                setStartDate(undefined);
                setEndDate(undefined);
              }}
            />
          )}
          {tags.map((tag) => (
            <Chip
              key={tag.Id}
              element={<>{tag.Name}</>}
              onDelete={() => {
                setTags(tags.filter((t) => t.Id !== tag.Id));
              }}
            />
          ))}
          {members.map((member) => (
            <Chip
              key={member.Id}
              avatar={
                <Avatar className={styles.avatar}>
                  {convertToLetters(member.Label)}
                </Avatar>
              }
              element={
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  {member.Label}
                </div>
              }
              onDelete={() => {
                setMembers(members.filter((f) => f.Id !== member.Id));
              }}
            />
          ))}
        </div>

        {/* <TextArea
          // className={styles.textarea}
          value={content}
          // minRows={size}
          onChange={(text) => {
            setContent(text);
          }}
          label=""
          size={size}
        /> */}
        <div className="h-[100%]">
          <RichEditor
            disableToolbar
            content={content}
            setContent={(text) => setContent(text)}
          />
        </div>
      </div>
    </>
  );
};

export default EventForm;
